export default __webpack_public_path__ + "static/media/ht.14c011dd.svg";